<template>
  <AppLayout><router-view /></AppLayout>
</template>

<script>
  import { onMounted } from "@vue/runtime-core";

  export default {
    name: "App",
    setup: () => {
      // mounted
      onMounted(() => {
        console.debug("Component App is mounted!");
      });
    },
    methods: {},
    computed: {},
  };
</script>
